import React from 'react';
import PropTypes from 'prop-types';
import logo from '../assets/logo_white_transparent_no_text.png';
import journal_left from '../assets/journal_1.png';
import journal_right from '../assets/journal_2.png';
import arrow from '../assets/yellow_arrow.png';

/**
 * MainIntro component - Displays the main introduction section of the application
 */
const MainIntro = (props) => {
    return (
        <div id={props.id}>
            <img src={logo} alt="logo" className="main-intro-logo" />
            <div className="main-intro-container">
                <img src={journal_left} className="main-intro-journal-entry-left" alt="Decorative journal entry" />    
                <h1 className="main-title-intro">The Autobiography,<br/>Reimagined</h1>
                <img src={journal_right} className="main-intro-journal-entry-right" alt="Decorative journal entry" />
            </div>
            <h2 className="main-subtitle-intro">(we're not your typical ghostwriter)</h2>
            <div className="main-intro-question-box">
                <h3 className="main-subsubtitle-intro">Are you excited to spend <span style={{fontWeight: 'bold'}}>$20,000+</span> on your autobiography?</h3>
                <h3 className="main-subsubtitle-intro bold">
                    Then go to our competitors
                    <span className="main-competitor-links">
                        <a className="main-competitor-box" href="https://www.lifebookmemoirs.com/packages/" target="_blank" rel="noopener noreferrer">1</a>
                        <a className="main-competitor-box" href="https://shop-us.storyterrace.com/products/pro" target="_blank" rel="noopener noreferrer">2</a>
                    </span>
                </h3>
            </div>
            <h3 className="main-subsubtitle-intro">Too expensive? <span className="main-handwritten-underline">We agree.</span></h3>
            <img src={arrow} className="main-intro-yellow-arrow" alt="Directional arrow" />
        </div>
    );
};

// PropTypes for type checking
MainIntro.propTypes = {
    id: PropTypes.string
};

export default MainIntro;